/**
 * Microdose — AJAX add to cart with Dawn cart drawer / icon refresh (no page reload).
 */
(function () {
  'use strict';

  function getSectionInnerHTML(html, selector) {
    selector = selector || '.shopify-section';
    var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsed ? parsed.innerHTML : '';
  }

  function getCartUI() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /**
   * Storefront display name from an admin title — mirror of
   * snippets/microdose-product-display-name.liquid for AJAX responses.
   * "Durban Zs - 1mg OR" / "Durban Zs - 1mg" / "Durban Zs (S)" → "Durban Zs".
   */
  function cleanProductName(title) {
    var t = String(title || '');
    t = t.split(' - ')[0].split(' \u2013 ')[0].trim();
    t = t.replace(/\s*\((S|I|H)\)\s*$/i, '').trim();
    t = t.replace(/(\s+(or|1mg))+$/i, '').trim();
    return t || String(title || '');
  }
  window.microdoseCleanProductName = cleanProductName;

  function bumpCartBubble() {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;
    bubble.classList.remove('is-bumped');
    void bubble.offsetWidth; // restart the animation
    bubble.classList.add('is-bumped');
  }

  /**
   * "Added to cart" toast — markup + CSS in snippets/microdose-cart-toast.liquid.
   * Shown instead of opening the drawer so shoppers can keep adding items
   * back to back; "View cart" opens the drawer.
   */
  var toast = (function () {
    var root = null;
    var els = {};
    var hideTimer = null;
    var deadline = 0;
    var remaining = 0;
    var DURATION = 4200;

    function init() {
      if (root) return true;
      root = document.querySelector('[data-md-cart-toast]');
      if (!root) return false;
      els.name = root.querySelector('[data-md-toast-name]');
      els.meta = root.querySelector('[data-md-toast-meta]');
      els.media = root.querySelector('[data-md-toast-media]');
      els.img = root.querySelector('[data-md-toast-img]');
      els.view = root.querySelector('[data-md-toast-view]');
      els.close = root.querySelector('[data-md-toast-close]');
      els.timer = root.querySelector('[data-md-toast-timer]');

      if (els.view) {
        els.view.addEventListener('click', function () {
          hide();
          if (typeof window.microdoseCloseShopWidget === 'function') window.microdoseCloseShopWidget();
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open(els.view);
          } else if (drawer) {
            // cart-drawer.js has not upgraded the element yet: open it by hand
            // rather than sending the shopper to the cart page.
            document.body.classList.add('overflow-hidden');
            setTimeout(function () {
              drawer.classList.add('animate', 'active');
            });
          } else if (window.routes && window.routes.cart_url) {
            window.location.href = window.routes.cart_url;
          } else {
            window.location.href = '/cart';
          }
        });
      }
      if (els.close) els.close.addEventListener('click', hide);
      root.addEventListener('mouseenter', pause);
      root.addEventListener('focusin', pause);
      root.addEventListener('mouseleave', resume);
      root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget)) resume();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !root.hidden) hide();
      });
      return true;
    }

    function offsetBelowHeader() {
      var header =
        document.querySelector('.header-wrapper') ||
        document.querySelector('#shopify-section-header') ||
        document.querySelector('.section-header');
      if (!header) return 12;
      var rect = header.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.height === 0) return 12;
      return Math.round(rect.bottom) + 10;
    }

    function thumb(url) {
      if (!url) return '';
      return String(url).replace(/(\.(?:png|jpe?g|webp|gif))(\?.*)?$/i, '_160x160$1$2');
    }

    function armTimer(ms) {
      clearTimeout(hideTimer);
      deadline = Date.now() + ms;
      hideTimer = setTimeout(hide, ms);
      if (els.timer) {
        root.style.setProperty('--md-toast-duration', ms + 'ms');
        root.classList.remove('is-paused');
      }
    }

    function pause() {
      if (!root || root.hidden || !hideTimer) return;
      clearTimeout(hideTimer);
      hideTimer = null;
      remaining = Math.max(deadline - Date.now(), 800);
      if (els.timer) {
        var tf = window.getComputedStyle(els.timer).transform;
        root.classList.add('is-paused');
        els.timer.style.transform = tf && tf !== 'none' ? tf : 'scaleX(0)';
      }
    }

    function resume() {
      if (!root || root.hidden || hideTimer) return;
      if (els.timer) {
        els.timer.style.transform = '';
        root.classList.remove('is-paused');
      }
      armTimer(remaining || DURATION);
    }

    function show(item) {
      if (!init()) return;
      item = item || {};
      var title = cleanProductName(item.product_title || item.title || '');
      if (els.name) els.name.textContent = title || 'Item';

      var metaBits = [];
      if (item.variant_title && !/default title/i.test(item.variant_title)) metaBits.push(item.variant_title);
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        metaBits.push(item.selling_plan_allocation.selling_plan.name || 'Subscription');
      }
      if (item.quantity && Number(item.quantity) > 1) metaBits.push('Qty ' + item.quantity);
      if (els.meta) {
        els.meta.textContent = metaBits.join(' \u00b7 ');
        els.meta.hidden = metaBits.length === 0;
      }

      var image = item.image || (item.featured_image && item.featured_image.url) || '';
      if (els.media && els.img) {
        if (image) {
          els.img.src = thumb(image);
          els.img.alt = '';
          els.media.hidden = false;
        } else {
          els.media.hidden = true;
        }
      }

      root.style.setProperty('--md-toast-offset', offsetBelowHeader() + 'px');
      root.classList.remove('is-open', 'is-paused');
      if (els.timer) els.timer.style.transform = '';
      root.hidden = false;
      // Two frames so the entrance transition runs from the hidden state.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('is-open');
        });
      });
      remaining = 0;
      armTimer(DURATION);
    }

    function hide() {
      if (!root || root.hidden) return;
      clearTimeout(hideTimer);
      hideTimer = null;
      root.classList.remove('is-open', 'is-paused');
      var card = root.querySelector('.md-cart-toast__card');
      var done = function () {
        root.hidden = true;
      };
      if (card) {
        var fired = false;
        card.addEventListener(
          'transitionend',
          function () {
            if (fired) return;
            fired = true;
            done();
          },
          { once: true }
        );
        setTimeout(function () {
          if (fired) return;
          fired = true;
          done();
        }, 400);
      } else {
        done();
      }
    }

    return { show: show, hide: hide };
  })();
  window.microdoseCartToast = toast;

  function getSectionsToRequest() {
    var cartUI = getCartUI();
    if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
      return cartUI.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }
    return ['cart-icon-bubble'];
  }

  function applyCartSections(sections, openDrawer) {
    if (!sections) return;

    var cartUI = getCartUI();
    var renderList =
      cartUI && typeof cartUI.getSectionsToRender === 'function'
        ? cartUI.getSectionsToRender()
        : [{ id: 'cart-icon-bubble' }];

    renderList.forEach(function (section) {
      if (!sections[section.id]) return;

      var sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      sectionElement.innerHTML = getSectionInnerHTML(
        sections[section.id],
        section.selector || '.shopify-section'
      );
    });

    bumpCartBubble();

    if (cartUI) {
      cartUI.classList.remove('is-empty');
      var itemsEl = cartUI.querySelector('cart-drawer-items');
      if (itemsEl) itemsEl.classList.remove('is-empty');

      if (openDrawer && typeof cartUI.open === 'function') {
        setTimeout(function () {
          var overlay = cartUI.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', cartUI.close.bind(cartUI));
          cartUI.open();
        });
      }
    }
  }

  function parseJsonResponse(res) {
    return res.text().then(function (text) {
      var data = null;
      if (text) {
        try {
          data = JSON.parse(text);
        } catch (e) {
          data = null;
        }
      }

      if (!res.ok) {
        var message =
          (data && (data.description || data.message)) ||
          (res.status === 401
            ? 'Cart session expired. Refresh the page and try again.'
            : 'Add to cart failed (' + res.status + '). Please try again.');
        throw new Error(message);
      }

      if (!data) {
        throw new Error('Cart response was empty. Refresh the page and try again.');
      }

      return data;
    });
  }

  function fetchCartSections() {
    var ids = getSectionsToRequest().join(',');
    return fetch(window.location.pathname + '?sections=' + ids).then(parseJsonResponse);
  }

  function publishCartUpdate(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'microdose-cart',
        cartData: cartData,
      });
    }
    window.dispatchEvent(
      new CustomEvent('microdose:cart-updated', {
        detail: { cart: cartData },
      })
    );
  }

  /**
   * @param {number|string} variantId
   * @param {Object} [options]
   * @param {number} [options.quantity]
   * @param {number|string} [options.sellingPlanId]
   * @param {boolean} [options.openDrawer]  open the cart drawer after adding
   * @param {boolean} [options.toast]       show the "Added to cart" toast instead
   * @returns {Promise}
   */
  window.microdoseAddToCart = function (variantId, options) {
    options = options || {};

    if (!variantId) {
      return Promise.reject(new Error('No variant selected'));
    }

    if (!window.routes || !window.routes.cart_add_url) {
      return Promise.reject(new Error('Cart routes unavailable'));
    }

    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(options.quantity || 1));

    if (options.sellingPlanId) {
      formData.append('selling_plan', String(options.sellingPlanId));
    }

    var sectionIds = getSectionsToRequest();
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      body: formData,
    })
      .then(parseJsonResponse)
      .then(function (response) {
        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'microdose-cart',
              errors: response.description,
              message: response.message,
            });
          }
          throw new Error(response.description || response.message || 'Add to cart failed');
        }

        var openDrawer = options.openDrawer === true;
        var showToast = options.toast === true && !openDrawer;
        // /cart/add.js answers with the line item (or {items:[...]} for multi-add).
        var addedItem = response.items && response.items.length ? response.items[0] : response;

        var sectionsReady;
        if (response.sections) {
          applyCartSections(response.sections, openDrawer);
          sectionsReady = Promise.resolve();
        } else {
          sectionsReady = fetchCartSections().then(function (sections) {
            applyCartSections(sections, openDrawer);
          });
        }

        return sectionsReady.then(function () {
          if (showToast) toast.show(addedItem);
          return fetch('/cart.js', {
          headers: { Accept: 'application/json' },
        })
            .then(parseJsonResponse)
            .then(function (cart) {
              publishCartUpdate(cart);
              return { response: response, cart: cart };
            });
        });
      });
  };

  window.microdoseRefreshCart = function (openDrawer) {
    return fetchCartSections().then(function (sections) {
      applyCartSections(sections, openDrawer === true);
      return fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      })
        .then(parseJsonResponse)
        .then(function (cart) {
          publishCartUpdate(cart);
          return cart;
        });
    });
  };
})();
